import noAuthHttp from 'hub-http/clients/noAuthApiClient';
export default class API {
  makeGetRequest(url, options) {
    return noAuthHttp.getWithResponse(url, options);
  }
  makePostRequest(url, options) {
    return noAuthHttp.post(url, options);
  }
}